import script from "./UiFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./UiFooter.vue?vue&type=script&setup=true&lang=js"

import "./UiFooter.vue?vue&type=style&index=0&id=6c114552&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c114552"]])

export default __exports__